import React from 'react';
import styled from 'styled-components';
import { Spin } from 'udesk-ui';
import SimplePieChart from 'src/pages/coach/task-center/components/SimplePieChart';
import Udesk from 'Udesk';
import { IntelligentPartnerCourseHomePageAdminCourseSocresResponse } from 'src/api/types';

const ChartsWrapper = styled.div`
    display: flex;
    flex: 1;
    > div {
        flex: 1;
    }
`;

interface ScoreCardsProps {
    loading?: boolean;
    data?: IntelligentPartnerCourseHomePageAdminCourseSocresResponse;
}

export const ScoreCards: React.FC<ScoreCardsProps> = ({ loading = false, data }) => {
    const scoreCharts = [
        {
            id: 'courseQuality',
            title: data?.courseQualityAvg?.toFixed(2) ?? '0.00',
            subTitle: Udesk.enums.coachScoreTypes.courseQuality.name,
            value: data?.courseQualityAvg ?? 0,
        },
        {
            id: 'learningEffect',
            title: data?.learningEffectAvg?.toFixed(2) ?? '0.00',
            subTitle: Udesk.enums.coachScoreTypes.learningEffect.name,
            value: data?.learningEffectAvg ?? 0,
        },
        {
            id: 'interactionExperience',
            title: data?.interactionExperienceAvg?.toFixed(2) ?? '0.00',
            subTitle: Udesk.enums.coachScoreTypes.interactionExperience.name,
            value: data?.interactionExperienceAvg ?? 0,
        },
        {
            id: 'overallScore',
            title: data?.overallScoreAvg?.toFixed(2) ?? '0.00',
            subTitle: Udesk.enums.coachScoreTypes.overallScore.name,
            value: data?.overallScoreAvg ?? 0,
        },
    ];

    if (loading) {
        return (
            <div className="udesk-qa-web-coach-evaluation-overview-card-content">
                <Spin />
            </div>
        );
    }

    return (
        <div className="udesk-qa-web-coach-evaluation-overview-card-content">
            <ChartsWrapper>
                {scoreCharts.map((chart) => (
                    <SimplePieChart
                        key={chart.id}
                        id={chart.id}
                        loading={loading}
                        height={140}
                        showTip={false}
                        title={chart.title}
                        subTitle={chart.subTitle}
                        data={[
                            { name: '已完成', value: chart.value },
                            { name: '未完成', value: 100 - chart.value },
                        ]}
                        textFontSize={16}
                    />
                ))}
            </ChartsWrapper>
        </div>
    );
};
